
















































import {Vue, Component, Prop, Emit} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "../../../mixins/table-editors.mixin";
import {TrosakPuta} from "@/services/BackendProxies";
import {formatPrice} from "@/utils/formatters";

@Component({})
export default class TroskoviPutnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop() troskovi!: TrosakPuta[];

    cenaFocusOut(row) {
        row.iznos = formatPrice(row.iznos);
    }

    dodajTrosak(row) {
        if (row instanceof MouseEvent) {
            const index = this.troskovi.length ? this.troskovi.length - 1 : 0;
            if (index) {
                row = this.troskovi[index];
            }
        }
        this.troskovi.push(TrosakPuta.fromJS({datum: row.datum, iznos: 0}));
    }

    @Emit() obrisiTrosak(row: TrosakPuta) {}

    fokusirajCeliju(dataCellValue) {
        this.$nextTick(() => {
            $(`[data-cell="${dataCellValue}"]`).focus();
        });
    }

}
